export const AuthErrorCode = {
  UNAUTHORIZED: 'Unauthorized',
} as const;
